/* src/app/components/control-module/process/process.component.css */
.bgk {
  padding: 10px 0px;
  border: 1px solid hsla(0, 0%, 91%, 0.949);
  border-radius: 4px;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  background-color: var(--navy-100);
  border-right: 1px solid var(--bg-surface);
  color: var(--navy-600);
  font-weight: var(--weight-semibold);
  z-index: 5;
}
.nav-pills:hover .nav-link.active:hover,
.nav-pills:hover .show:hover > .nav-link:hover {
  background-color: var(--navy-100);
}
.nav-link:hover {
  background-color: var(--navy-100);
}
/*# sourceMappingURL=process.component.css.map */
